// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function pushToDataLayer(data: any): void {
    if (typeof window !== 'undefined') {
        window.dataLayer.push(data);
    }
}
